/* eslint-disable no-console */
import axios from "@/services/middleware/client";

export function getPaymentsUrl(): Promise<any> {
  return axios
    .get("/account/payment-page")
    .then((res) => res)
    .catch((error) => {
      console.error("axios error", error);
    });
}
